/**
 * Thin Day.js wrapper replacing moment.
 * HITO weeks start Monday (ISO). Always use the return value of .add()/.startOf().
 */
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale.js';

dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });

export default dayjs;
